<template>
  <div class="common-box">
    <el-row class="row-one">
      <span class="row-one-title">调仓详情</span>
      <Reback class="row-one-fr" @click.native="$router.push({ name: 'combinationAdjustRecord' })"></Reback>
    </el-row>
    <!-- 详情 -->
    <section class="xDetail" style="width:554px;">
      <div class="aujustTit">
        <span class="aujustTit-name">{{message.combinationName}}</span>
        <span class="aujustTit-status margin-l10">{{message.statusName}}</span>
      </div>
      <!-- 卖出 -->
      <table class="table-normal-two margin-t15" cellspacing="0">
        <thead>
          <tr>
            <th>卖出</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,i) in sellTableData" :key="i+'sell'">
            <td>{{item.fundname}}</td>
            <td>
              <span>卖出 </span>
              <span class="aColor">{{parseFloat(item.amountorfundvol).toFixed(2)}}份 </span>
              <span>{{item.statusName}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 买入 -->
      <table class="table-normal-two margin-t15" cellspacing="0">
        <thead>
          <tr>
            <th>买入</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,i) in buyTableData" :key="i+'buy'">
            <td>{{item.fundname}}</td>
            <td v-if="item.status == 2">
              <span>尚未进行申购</span>
            </td>
            <td v-else-if="item.status == 6">
              <span>买入 </span>
              <span class="aColor">1000份 </span>
              <span>{{item.statusName}}</span>
            </td>
            <td v-else-if="item.status == 4 || item.status == 5">
              <span>已撤单</span>
            </td>
            <td v-else>
              <span>买入 </span>
              <span class="aColor">{{parseFloat(item.amountorfundvol).toFixed(2)}}元 </span>
              <span>{{item.statusName}}</span>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 调仓申请 -->
      <table class="table-normal-two margin-t15" cellspacing="0">
        <thead>
          <tr>
            <th>调仓申请</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>组合名称</td>
            <td>{{message.combinationName}}</td>
          </tr>
          <tr>
            <td>方案发布时间</td>
            <td>{{message.storehousedate}}</td>
          </tr>
          <tr>
            <td>组合操作时间</td>
            <td>{{message.operdate}}</td>
          </tr>
        </tbody>
      </table>
      <!-- 调仓详情 -->
      <div class="xDetail-stepstwo" style="width:554px;">
        <el-table :data="detailsTableData" class="table-single table-adjust" :span-method="objectSpanMethod">
          <el-table-column label="调仓详情" prop="fundType" width="100"></el-table-column>
          <el-table-column prop="fundname">
            <template slot-scope="scope">
              <span>{{scope.row.fundname == 0? scope.row.newfundname:scope.row.fundname}} </span>
              <span class="aColor">{{scope.row.fundcode == 0?  scope.row.newfundcode:scope.row.fundcode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="调仓前" prop="rate" width="110">
            <template slot-scope="scope">
              <span>{{parseFloat(scope.row.rate*100).toFixed(2)}}%</span>
            </template>
          </el-table-column>
          <el-table-column label="调仓后" prop="newrate" width="110">
            <template slot-scope="scope">
              <span>{{parseFloat(scope.row.newrate*100).toFixed(2)}}%</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="aujustTit margin-t20">
        <div>
          <span>调仓费用：</span>
          <span class="aColor fr">{{rate}}元</span>
        </div>
        <div class="margin-t10">
          <span>订单编号：</span>
          <span class="aColor fr">{{message.combuyappsheetno}}</span>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      sellTableData: [],
      buyTableData: [],
      applyTableData: [],
      detailsTableData: [],
      message: '',
      rate: '',
      // 合并单元格  
      rowList: [],
      rowListpos: 0
    }
  },
  created () {
    this.message = this.$route.params.message
  },
  mounted () {
    this.getAdjustDetails()
  },
  methods: {
    // 详情
    getAdjustDetails () {
      this.$http.get(this.$apiPath.getTiaocangIn, {
        custno: this.$commonJs.getCookie('u_custno1'),
        combinationcode: this.message.combinationcode,
        transactionaccountid: this.message.transactionaccountid,
        combuyappsheetno: this.message.combuyappsheetno
      }).then(res => {
        // console.log(this.$commonJs.getJsonByXml(res.data));
        let data = this.$commonJs.getJsonByXml(res.data)
        // 买入卖出
        data.data1.forEach(item => {
          if (item.status == 2 || item.status == 6) {
            item.statusName = "确认中"
          } else if (item.status == 8) {
            item.statusName = "已确认"
          } else if (item.status == 4 || item.status == 5) {
            item.statusName = "已撤单"
          }
          if (item.sellorbuy == 1) {//卖出
            this.sellTableData.push(item)
          } else {//买入
            this.buyTableData.push(item)
          }
          // 调仓费用
          if (item.sellorbuy == 1) {
            this.rate = parseFloat(item.charge).toFixed(2)
          }
        })
        // 调仓详情
        this.detailsTableData = data.data2
        this.detailsTableData.forEach(item => {
          item.fundType = item.fundcode == 0 ? this.$parameterConfig.p_fundtype[item.newfundtype].replace("基金", "") : this.$parameterConfig.p_fundtype[item.fundtype].replace("基金", "");
        })
        this.detailsTableData.sort(function (a, b) {
          return a.fundType.localeCompare(b.fundType)
        })
        this.getRowList();//后台获取到数据后进行数据处理
      }).catch(err => { })
    },
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (this.rowList[rowIndex]) {
          const rowNum = this.rowList[rowIndex]
          return {
            rowspan: rowNum,
            colspan: rowNum > 0 ? 1 : 0
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    // 为表格行合并准备数据
    getRowList () {
      this.rowList = []
      this.rowListpos = 0
      this.detailsTableData.forEach((item, index, arr) => {
        // console.log(item.fundType);
        // 表格第一行必须保留
        if (index === 0) {
          this.rowList.push(1)
          this.rowListpos = 0
        } else {
          // 判断当前行性别与上一行性别是否相同 如果相同则合并
          if (item.fundType === arr[index - 1].fundType) {
            this.rowList[this.rowListpos] += 1 //需要合并的行数累加1
            this.rowList.push(0)
          } else {
            this.rowList.push(1)
            this.rowListpos = index
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
.aujustTit {
  font-size: 16px;
  &-name {
    font-weight: bold;
  }
  &-status {
    padding: 0 15px;
    display: inline-block;
    height: 24px;
    line-height: 24px;
    background: #4f8bbd;
    color: @wColor;
    border-radius: 3px;
  }
}
.table-normal-two {
  width: 100%;
  border: 1px solid @colorE5;
  thead {
    tr {
      //   height: 22px;
      background: @color;
      color: @wColor;
      text-align: left;
      th {
        padding: 7px 30px;
      }
    }
  }
  tbody {
    td {
      font-size: 14px;
      color: @color3;
      padding: 6px 30px;
      border-bottom: 1px dashed @colorE5;
    }
    tr {
      td:last-child {
        border-right: 0;
        text-align: right;
      }
    }
    tr:last-child td {
      border-bottom: 0;
    }
    .tr-one td {
      border-right: none;
      color: @color;
    }
  }
}
.table-adjust .el-table__body-wrapper table tr td {
  border-right: 1px dashed @colorE5;
}
</style>